import React from 'react'

import Icon from 'Core/Components/Icon'
import CopyButton from 'Core/Components/CopyButton'

import { keyState, imageAssetTypes, getAssetAttributes, getIconForAsset, assetsViewLayoutTypes, transformAssetList } from './assets-utils'

export const AssetsTileView = ({ assets, selection, onSelectionChange, onSelectDirectory, onFileDelete, onFileRename, onDirectoryRename, onDirectoryDelete }) => {
    return (
        <div className="row items-stretch justify-start">
            {assets.map((asset, index) => {
                const attributes = getAssetAttributes(asset)
                const toggledSelection = selection.includes(asset.uri)
                    ? selection.filter(u => u !== asset.uri)
                    : [...selection, asset.uri]

                return (
                    <div
                        key={index}
                        onClick={() => keyState.cmdActive || keyState.ctrlActive ? onSelectionChange(toggledSelection) : onSelectionChange([asset.uri])}
                        onDoubleClick={() => asset.type === 'directory' ? onSelectDirectory(asset.uri) : null}
                        className={`stack-fluid xs-12 sm-6 md-4 flex-1 lg-3 xl-2 asset-card ${selection.includes(asset.uri) ? 'asset-card--active' : ''}`}>

                        <div className="items-center justify-center" style={{ cursor: 'pointer', height: 120, marginBottom: 10, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                            {imageAssetTypes.includes(asset.type.toLowerCase()) ? (
                                <img
                                    src={asset.uri}
                                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                                  />
                            ) : (
                                <React.Fragment>
                                    <Icon style={{ fontSize: 60, marginTop: 15 }} fa={getIconForAsset(asset)}/>
                                    <h3 style={{ marginTop: 5, fontWeight: 200 }}>{asset.type === 'directory' ? '' : '.' + asset.type.toLowerCase()}</h3>
                                </React.Fragment>
                            )}
                        </div>
                        <h4 className="black-bg white" style={{ padding: '5px 10px', margin: 0, fontWeight: 500, wordWrap:'break-word', textAlign: 'center' }}>
                            {asset.name}
                        </h4>
                        <div
                            className="row yellow-bg items-center"
                            style={{ marginTop: 0, marginBottom: 10, cursor: 'pointer', padding: '3px 5px 3px 10px', whiteSpace: 'nowrap', overflow: 'hidden', flexWrap: 'nowrap', width: '100%' }}>
                            <code style={{ fontSize:10, lineHeight:'16px', flex: 1 }}>{asset.uri}</code>
                            <CopyButton text={asset.uri} />
                        </div>

                        <div className="stack" style={{ fontSize: 11, lineHeight: '16px' }}>
                            <div className="f-row" style={{ justifyContent: 'space-between' }}>
                                {attributes.map(attr => (
                                    <div key={attr.label} className="f-stack" style={{ marginTop: 0, justifyContent: 'flex-start', alignItems: 'flex-start' }}>
                                        <span style={{color:'#aaa'}}>
                                            {attr.label}
                                        </span>
                                        <div className="f-stack" style={{ alignItems: 'flex-start' }}>
                                            {attr.value}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div style={{ display: 'flex', marginBottom: -5, flexDirection: 'row', alignItems: 'center'}}>
                                {asset.type === 'directory'
                                    ? (
                                        <React.Fragment>
                                            <a className="btn btn-calm" onClick={(e) => e.stopPropagation() || setTimeout(() => onSelectDirectory(asset.uri))}>
                                                <Icon fa="hand-o-right" /><br/> Open
                                            </a>
                                            <button className="btn-warn" onClick={(e) => e.stopPropagation() || onDirectoryRename(asset.uri)}>
                                                <Icon fa="i-cursor" /><br/> Rename
                                            </button>
                                            <button className="btn-danger" onClick={(e) => e.stopPropagation() || onDirectoryDelete(asset.uri)}>
                                                <Icon fa="trash" /><br/> Delete
                                            </button>
                                        </React.Fragment>
                                    )
                                    : (
                                        <React.Fragment>
                                            <a className="btn btn-calm" href={asset.uri} target="_blank">
                                                <Icon fa="external-link" style={{margin: '-1px 0 5px', fontSize:15 }} />
                                                <br/>
                                                Open
                                            </a>
                                            <button className="btn-success" onClick={() => navigator.clipboard.writeText(window.location.protocol.concat('//', window.location.host, asset.uri))}>
                                                <Icon fa="copy" style={{margin: '-1px 0 5px', fontSize:15 }} />
                                                <br/>
                                                Copy URL
                                            </button>
                                            <button className="btn-warn" onClick={() => onFileRename(asset.uri)}>
                                                <Icon fa="i-cursor" style={{margin: '-1px 0 5px', fontSize:15 }} />
                                                <br/>
                                                Rename
                                            </button>
                                            <button className="btn-danger" onClick={() => onFileDelete(asset.uri)}>
                                                <Icon fa="trash" style={{margin: '-1px 0 5px', fontSize:15 }} />
                                                <br/>
                                                Delete
                                            </button>
                                        </React.Fragment>
                                    )}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    )
}



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Panes/Assets/AssetsTileView.jsx